/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-28 16:19:29
 * @LastEditors: changfeng
 * @LastEditTime: 2024-01-30 15:26:07
 */
export function getQueryVariable(variable: string) {
  console.log("decodeURI(window.location.href)", decodeURI(window.location.href))
  console.log("decodeURI(window.location.href)???",decodeURIComponent(decodeURI(window.location.href)))
  
  const query = decodeURIComponent(decodeURI(window.location.href)).split("?")?.[1];
  if (!query) {
    return undefined
  }
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return undefined;
}

export const SaveTokenToLocalStorage = (token: string) => {
  localStorage.setItem('Authorization', token);
};

export const MoveTokenFromLocalStorage = (): void => {
  localStorage.setItem('Authorization', '');
};

export const getAccessToken = (): string => {

  console.log("localStorage.getItem('Authorization')",localStorage.getItem('Authorization'))
  return localStorage.getItem('Authorization');
};

// 获取最大公约数
function getGcd(a, b) {
  let n1, n2;
  if (a > b) {
    n1 = a;
    n2 = b;
  } else {
    n1 = b;
    n2 = a;
  }

  const remainder = n1 % n2;
  if (remainder === 0) {
    return n2;
  } else {
    return getGcd(n2, remainder);
  }
}
/** 获取上传视频的宽高比利 */

export async function getVideoScale(url) {
  const video = document.createElement('video');
  video.setAttribute('width', '10');
  video.setAttribute('height', '10');
  video.setAttribute(
    'style',
    'position: absolute;opacity: 0;z-index: -5;top: 0;',
  );
  video.setAttribute('src', url);

  document.body.appendChild(video);

  const p = new Promise(function (resolve, reject) {
    video.addEventListener('canplay', function (e) {
      const gcd = getGcd(e.target.videoWidth, e.target.videoHeight);
      resolve([e.target.videoWidth / gcd, e.target.videoHeight / gcd]);
    });
  });
  const res = await p;
  document.body.removeChild(video);
  return res;
}


export enum COUNTRY {
  "US" = "美国",
  "CA" = "加拿大",
  "DE" = "德国",
  "AU" = "澳大利亚",
  "GE" = "英国",
  "AR" = "阿根廷",
  "AT" = "奥地利",
  "BH"  =  "巴林",
  "BY"  =  "白俄罗斯",
  "BE"  =  "比利时",
  "BR"  =  "巴西",
  "KH"  =  "柬埔寨",
  "CL"  =  "智利",
  "CO"  =  "哥伦比亚",
  "CZ"  =  "捷克",
  "DK"  =  "丹麦",
  "EC"  =  "厄瓜多尔",
  "EG"  =  "埃及",
  "FI"  =  "芬兰",
  "FR"  =  "法国",
  "GR"  =  "希腊",
  "HU"  =  "匈牙利",
  "ID"  =  "印度尼西亚",
  "IQ"  =  "伊拉克",
  "IE"  =  "爱尔兰",
  "IL"  =  "以色列",
  "IT"  =  "意大利",
  "JP"  =  "日本",
  "JO"  =  "约旦",
  "KZ"  =  "哈萨克斯坦",
  "KR"  =  "韩国",
  "KW"  =  "科威特",
  "LB"  =  "黎巴嫩",
  "MY"  =  "马来西亚",
  "MX"  =  "墨西哥",
  "MA"  =  "摩洛哥",
  "NL"  =  "荷兰",
  "NZ"  =  "新西兰",
  "NO"  =  "挪威",
  "OM"  =  "阿曼",
  "PK"  =  "巴基斯坦",
  "PE"  =  "秘鲁",
  "PH"  =  "菲律宾",
  "PL"  =  "波兰",
  "PT"  =  "葡萄牙",
  "QA"  =  "卡塔尔",
  "RO"  =  "罗马",
  "RU"  =  "俄罗斯",
  "SA"  =  "沙特阿拉伯",
  "SG"  =  "新加坡",
  "ZA"  =  "南非",
  "ES"  =  "西班牙",
  "SE"  =  "瑞典",
  "CH"  =  "瑞士",
  "TW"  =  "台湾省",
  "TH"  =  "泰国",
  "TR"  =  "土耳其",
  "UA"  =  "乌克兰",
  "AE"  =  "阿拉伯联合酋长国",
  "GB"  =  "英国",
  "UY"  =  "乌拉圭",
  "VN"  =  "越南"

}
